import {
  INICIALITZAR,
  INTRODUCCIO_OBTENIR_DADES
} from "../../actions/actionTypes";

const ESTAT_INICIAL = "";

const dataDarreraIntroduccio = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${INTRODUCCIO_OBTENIR_DADES}_SUCCESS`:
      return action.payload.dataDarreraIntroduccio;

    default:
      return state;
  }
};

export default dataDarreraIntroduccio;

export const getDataDarreraIntroduccio = state => state;
